import React, { useRef } from 'react';
import { Image } from 'semantic-ui-react-bpm';
import { icons } from '../../../../../../../../../common/icons';
import { useDrag, DragSourceMonitor, useDrop } from 'react-dnd';
import { DragObjectBPRef, IFormRelatedField } from '../interface/bp-relationship-field';
import SVGWrapper from '../../../../../../../../../common/icons/svg/svg-wrapper';

interface IRelationConfigModalFieldProps {
  fieldType: 'header' | 'content';
  field: IFormRelatedField;
  removeField(index: number, fieldType: string): void;
  updateField(index: number, tempField: IFormRelatedField, fieldType: "header" | "content"): void;
  sortField(selectedItem: DragObjectBPRef, fieldId: string): void;
  index: number;
  dropField(selectedItem: DragObjectBPRef, type: 'header' | 'content'): void;
}

const FieldList: React.FC<IRelationConfigModalFieldProps> = (props) => {
  const divRef = useRef<HTMLDivElement>(null);

  const [, dragSortFieldRef] = useDrag({
    item: { type: props.fieldType, data: props.field, index: props.index, fieldType: props.fieldType },
    collect: (monitor: DragSourceMonitor) => {
      return {
        opacity: monitor.isDragging() ? 0.5 : 1,
      }
    },
  });

  const [, dropSortFieldRef] = useDrop({
    accept: props.fieldType,
    drop: (selectedItem: DragObjectBPRef) => {
      props.sortField(selectedItem, props.field.id);
    }
  });

  dragSortFieldRef(dropSortFieldRef(divRef));

  return <div className='content-field-container' ref={divRef}>
    <div className={`content-field`}>
      <Image src={icons.blue.dragIcon} />
      <label>{props.field.name}
        <Image src={icons.blue.close}
          onClick={() => props.removeField(props.index, props.fieldType)}
        />
      </label>
    </div>
    <div className='field-label' onClick={() => {
      const tempField = { ...props.field };
      tempField.showLabel = !(tempField.showLabel);
      props.updateField(props.index, tempField, props.fieldType);
    }}>
      {!props.field.showLabel &&
        <svg className='slash' width="17" height="17" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="14.3536" y1="0.353553" x2="0.353553" y2="14.3536" stroke="#8A9296" />
        </svg>
      }
      <SVGWrapper color='#8A9296' iconName='eye' width='17' height='17' />
    </div>
  </div>
}

const RelationConfigModalField: React.FC<IRelationConfigModalFieldProps> = (props) => {
  return (
    <div className='content-field-main'>
      <FieldList
        field={props.field}
        fieldType={props.fieldType}
        sortField={props.sortField}
        updateField={props.updateField}
        removeField={props.removeField}
        index={props.index}
        dropField={props.dropField}
      />
    </div>
  )
}

export default RelationConfigModalField;